<template>
  <button 
    class="action-btn" 
    :class="buttonClass"
    @click="$emit('click', $event)"
    @mousedown="isPressed = true"
    @mouseup="isPressed = false"
    @mouseleave="isPressed = false"
  >
    <slot name="prefix"></slot>
    <span class="action-text">{{ text }}</span>
  </button>
</template>

<script>
export default {
  name: 'ActionButton',
  props: {
    text: {
      type: String,
      required: true
    },
    defaultColor:{
      type: String,
      default: '#374957'
    },
    hoverTextColor: {
      type: String,
      default: '#004879'
    },
    pressedTextColor: {
      type: String,
      default: '#004879'
    },
    hoverBgColor: {
      type: String,
      default: '#00487914'
    },
    pressedBgColor: {
      type: String,
      default: '#00487914'
    }
  },
  emits: ['click'],
  data() {
    return {
      isPressed: false
    };
  },
  computed: {
    buttonClass() {
      return {
        'is-pressed': this.isPressed
      };
    }
  }
};
</script>

<style scoped>
.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  min-width: 24px;
  border: none;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.5s ease;
  white-space: nowrap;
  color: v-bind(defaultColor);
  box-sizing: border-box;
}

.action-btn :deep(svg) {
  flex-shrink: 0;
  display: block;
  max-height: 24px;
  max-width: 24px;
}

.action-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  max-width: 0;
  overflow: hidden;
  opacity: 0;
  transition: all 0.5s ease;
}

.action-btn:hover {
  background: v-bind(hoverBgColor);
  padding: 2px 6px;
  color: v-bind(hoverTextColor);
}

.action-btn:hover .action-text {
  max-width: fit-content;
  opacity: 1;
  color: v-bind(hoverTextColor);
  margin-left: 4px;
  text-decoration: underline;
  text-decoration-thickness: 1px;
}

.action-btn.is-pressed {
  background: v-bind(pressedBgColor);
  color: v-bind(pressedTextColor);
}

.action-btn.is-pressed .action-text {
  color: v-bind(pressedTextColor);
}
</style>
